import { getAction } from '@/api/manage'

const API_BASE = '/api/plugin/sale-ratio-statistics/saleRatioStatistics'

export function getList(params) {
  return getAction(`${API_BASE}/getList`, params)
}

export default { getList }